import {create} from "zustand";
import { subscribeWithSelector, persist } from 'zustand/middleware'
import {getCurrentUser, loginUser} from "../api/users";
import {difference, intersection} from "lodash";

const useUserStore = create(
    persist(
        subscribeWithSelector((set) => ({
            user: {
                status: null,
                email: '',
                username: '',
                permissions: [],
                roles: [],
                partners: [],
            },
            accessToken: '',
            login: async (email, password) => {
                const response = await loginUser(email, password);
                const responseUser = response.data;

                if (responseUser.success === true) {

                    const user = responseUser.data;

                    set((state) => ({
                        user: {
                            ...state.user,
                            email: user.email,
                            status: 'login'
                        },
                        accessToken: user.token
                    }))

                    await useUserStore.getState().loadUserInfo()
                    return true
                }
            },
            loadUserInfo: async () => {
                const response = await getCurrentUser();
                const responseUserInfo = response.data;
                if (responseUserInfo.success === true) {
                    const userInfo = response.data.data;

                    set((state) => ({
                        user: {...state.user,
                            id: userInfo.id,
                            email:userInfo.email,
                            roles: userInfo.roles ?? [],
                            permissions: userInfo.permissions ?? [],
                            partners: userInfo.partners ?? [],
                            metadata: userInfo.metadata,
                        }
                    }))
                }
            },
            logoutUser: async () => {
                set({
                    accessToken: null,
                    user : {
                        status: null,
                        email: '',
                        username: '',
                        permissions: '',
                        roles: ''
                    },
                });

            },
            can: (requiredPermissions,inclusivePermission = false) => {
                return inclusivePermission
                    ? intersection(useUserStore.getState().user?.permissions, requiredPermissions).length
                    : difference(requiredPermissions, useUserStore.getState().user?.permissions).length === 0;
            }

        })),
        {
            name: 'user',
            merge: (persistedState, currentState) => ({
                ...currentState, ...(persistedState)
            })
        }
    )
) ;

export default useUserStore;